module.exports = __webpack_public_path__ + "img/empty-content.4e24737b.svg";